import { render, staticRenderFns } from "./sign_material.vue?vue&type=template&id=52388157&scoped=true"
import script from "./sign_material.vue?vue&type=script&lang=js"
export * from "./sign_material.vue?vue&type=script&lang=js"
import style0 from "./sign_material.vue?vue&type=style&index=0&id=52388157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52388157",
  null
  
)

export default component.exports